<template>
  <div class="template_spacing height vertical_layout">
    <breadcrumbModule :nav-data="navData"></breadcrumbModule>
    <div class="flex height" style="height: calc(100% - 45px)">
      <layoutModule>
        <template #top>
          <!-- 导航切换 -->
          <tabModule>
            <template #content>
              <section class="rm_spacing" v-for="(item, index) in typeList" :key="index" :class="{ active: index === tabIndex }">
                <el-button>{{ item.title }}</el-button>
              </section>
            </template>
          </tabModule>
        </template>
        <template #left>
          <div class="height vertical_layout">
            <div class="curLeftSearch">
              <el-form class="demo-ruleForm">
                <el-form-item style="margin-bottom: 5px">
                  <el-input v-model="queryInfo.butcherName" placeholder="输入名称搜索" style="width: 270px"></el-input>
                </el-form-item>
                <el-form-item v-show="areaLs" style="margin-bottom: 5px; margin-right: 10px">
                  <el-select
                    style="width: 130px"
                    v-if="areaLs && areaLs.provincialAndMunicipalLevel == '1'"
                    v-model="queryInfo.butcherCities"
                    placeholder="所在辖区"
                  >
                    <el-option v-for="item in option" :key="item.name" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                  <el-select
                    style="width: 130px"
                    v-if="areaLs && areaLs.provincialAndMunicipalLevel == '2'"
                    v-model="queryInfo.butcherArea"
                    placeholder="所在辖区"
                  >
                    <el-option v-for="item in option" :key="item.name" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                  <el-select
                    style="width: 130px"
                    v-if="areaLs && areaLs.provincialAndMunicipalLevel == '3'"
                    v-model="queryInfo.butcherArea"
                    placeholder="所在辖区"
                  >
                    <el-option
                      v-for="item in [{ name: '全部辖区', code: queryInfo.butcherArea }]"
                      :key="item.name"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 5px; margin-right: 0">
                  <el-select style="width: 130px" v-model="queryInfo.livestockName" placeholder="全部种类">
                    <el-option v-for="item in types" :key="item.valueDesc" :label="item.valueDesc" :value="item.valueDesc"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-show="areaLs !== null" style="margin-bottom: 5px; margin-right: 10px">
                  <el-select style="width: 270px" v-model="levelValue" placeholder="等级">
                    <el-option v-for="item in levels" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 5px; margin-right: 0">
                  <div class="projectFiltering" style="padding: 0">
                    <div class="projectFilteringAdd">
                      <div class="horizontal_layout" style="padding-top: 5px">
                        <el-button
                          v-for="(btn, btnIndex) in resetOrSearch"
                          :key="btnIndex"
                          :icon="btn.icon"
                          :class="btn.class"
                          @click="searchEvent(btn, 'left')"
                          >{{ btn.title }}</el-button
                        >
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="curLeftTotal">
              共 <span>{{ total }}</span> 条数据
            </div>
            <div class="flex" style="height: calc(100% - 216px)">
              <div class="tzcLeftList height y_scroll">
                <div class="indeJust height" v-if="lists.length === 0 && !loading">
                  <noData :imgSize="85"></noData>
                </div>
                <ul v-else>
                  <li v-for="(item, index) in lists" :key="index" :class="{ active: tabIndex == index }" @click="listItems(item, index)">
                    <section class="horizontal_layout_no">
                      <p class="flex overEllipsis">{{ item.name }}</p>
                      <p><span>AAA</span></p>
                    </section>
                    <section class="horizontal_layout_no">
                      <p class="flex">通道数量 {{ item.butcherStatusCount }}</p>
                      <p>{{ item.livestockName }}</p>
                    </section>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template #right>
          <div class="height vertical_layout">
            <div class="curRightHeader" v-if="detail">
              <aside class="title horizontal_layout_no">
                <p class="flex">{{ detail.name || '---' }}</p>
                <p>
                  <el-button size="mini" icon="el-icon-notebook-2" @click="checkInfo(detail)" v-if="detail.phone">查看资质信息</el-button>
                </p>
              </aside>
              <section class="horizontal_layout_no" style="padding-top: 10px">
                <p class="threeA">AAA</p>
                <p class="flex">{{ detail.livestockName }}</p>
              </section>
              <section class="horizontal_layout_no">
                <p>负责人：{{ detail.userName }}</p>
                <p class="line lmPad_spacing rmPad_spacing">|</p>
                <p>联系方式：{{ detail.phone }}</p>
              </section>
              <section class="" style="padding-bottom: 10px">
                <p @click="toMap" v-if="detail.address">
                  地址：{{ detail.address }}<a><strong class="map">（查看地图）</strong></a>
                </p>
              </section>
              <div class="lineWidth"></div>
              <section style="padding: 10px 0">
                <p>
                  通道数量：<span>{{ passagewayNum }}</span>
                </p>
              </section>
            </div>
            <div class="curRightContent y_scroll" style="height: 180px">
              <noData v-if="(accessList.length === 0 || !accessList) && !accessListLodaing" :imgSize="85"></noData>
              <ul v-for="(item, index) in accessList" :key="index" class="horizontal_layout_no">
                <li class="relative rm_spacing" @click="videoPlay(item, index)">
                  <div style="width: 320px; height: 180px" v-html="item.html"></div>
                  <div class="curPosition">
                    <p class="green" v-if="item.onLine == 0">实时监管中</p>
                    <p class="gray" v-else>设备已离线</p>
                  </div>
                </li>
                <li class="flex">
                  <div class="curRightConInfo horizontal_layout_no">
                    <p>{{ item.livestockName }}</p>
                    <p>{{ item.lockName }}</p>
                  </div>
                  <div class="curRightConList">
                    <section>
                      <p>今日进场次数</p>
                      <p>
                        <span class="number">{{ item.csize }}</span
                        >次
                      </p>
                    </section>
                    <section>
                      <p>今日进场数量</p>
                      <p>
                        <span class="number">{{ item.totalCount }}</span
                        >只
                      </p>
                    </section>
                    <section>
                      <p>通道状态</p>
                      <p class="grayCls" :class="{ greenCls: item.doorStatus == 0 }">{{ item.doorStatus == 0 ? '开启' : '关闭' }}</p>
                    </section>
                    <section>
                      <p>设备状态</p>
                      <p class="grayCls" :class="{ greenCls: item.onLine == 0 }">{{ item.onLine == 0 ? '在线' : '离线' }}</p>
                    </section>
                  </div>
                </li>
              </ul>
            </div>
            <div class="curRightBottomMain flex height" style="height: calc(100% - 350px)">
              <!-- <order ref="order" :searchData="resetOrSearch" v-if="itemInfo.applicationId == 16"></order> -->
              <!-- <div class="height indexJust" v-else>
                <noData :imgSize="85"></noData>
              </div> -->
            </div>
          </div>
        </template>
      </layoutModule>
    </div>
    <!-- 资质信息 -->
    <dialogEL title="资质信息" :visible="isShowPhoto" width="440px" :closeOnClickModal="false" @close="qualificationsClose">
      <template #dialogContent>
        <img v-if="infoPhotoUrl.indexOf('no_photo') > -1" width="200px" :src="infoPhotoUrl" alt="" />
        <img v-else width="400px" :src="infoPhotoUrl" alt="" />
        <div v-if="infoPhotoUrl.indexOf('no_photo') > -1">暂无资质信息</div>
      </template>
    </dialogEL>
    <!-- 视频播放 -->
    <el-dialog :visible.sync="showDialogDetail" width="660px" @click="closeDialog()">
      <div class="maskBoxs showDetails" v-if="showDetail">
        <div class="titleShow">{{ showDetail.lockName }}</div>
        <div style="margin-top: 20px">
          <div style="position: relative; height: 350px">
            <video muted class="video video-js vjs-big-play-centered vjs-default-skin" id="myVideo" autoplay controls></video>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'videojs-contrib-hls';
import 'video.js/dist/video-js.min.css';
import lang_zhcn from 'video.js/dist/lang/zh-CN.json';
videojs.addLanguage('zh-CN', lang_zhcn);
import { findDictList } from '@/api/material';
import { getButcherBeanList, getButcherLockBeanList, selectByAreas } from '@/api/slaughter';
import { queryUserCertFileList } from '@/api/slaughter';
import noPhoto from './static/no_photo.png';
import order from './components/order';

import noData from '@/components/module/noData/index.vue';
import loadingModule from '@/components/module/loading/loading.vue';
import layoutModule from '@/components/module/layout/index.vue';
import breadcrumbModule from '@/components/module/breadcrumb/index.vue';
import tabModule from '@/components/module/tabModule/index.vue';
import dialogEL from '@/components/module/dialogEL/index.vue';

import { slaughterCurNavData, resetOrSearch, slaughterTypeList } from '@/assets/data/smartAnimalHusbandry.js';
import common from '@/views/poultryStorage/commone/common.js';
export default {
  // 注册组件
  components: {
    order,
    noData,
    loadingModule,
    breadcrumbModule,
    tabModule,
    layoutModule,
    dialogEL
  },
  data() {
    return {
      navData: slaughterCurNavData,
      resetOrSearch: resetOrSearch,
      typeList: slaughterTypeList,
      tabIndex: 0,
      loading: true,
      showDialogDetail: false,
      value1: '',
      activeName: '屠宰场',
      breedRecordNo: '',
      type: [],
      xiafaList: [],
      showForm: {
        id: ''
      },
      showForm2: {
        id: ''
      },
      showFormVisible: false,
      showFormVisible2: false,
      handleIndex: 0,
      list: [],
      from: {
        recordNo: '',
        curDay: '',
        typeCode: '',
        name: '',
        code: ''
      },
      infoQuery: {
        recordNo: '',
        curDay: '',
        typeCode: '',
        type: 10,
        current: 1,
        size: 5,
        name: '',
        code: ''
      },
      total: 0,
      option: [
        {
          value: 'XX',
          label: 'XX'
        }
      ],
      types: [],
      levels: [
        {
          value: 'AAA',
          label: 'AAA'
        }
      ],
      value: '',
      typesValue: '',
      levelValue: '',
      lists: [],
      user: null,
      queryInfo: {
        current: 1,
        size: 100,
        userAccount: '',
        butcherName: '',
        livestockName: '',
        butcherProvinces: '', //省
        butcherCities: '', //市
        butcherArea: '' //区
      },
      queryLsInfo: {
        butcherId: ''
      },
      detail: null,
      accessList: [],
      accessListLodaing: false,
      videoIndex: 0,
      options: {
        autoplay: false, // 设置自动播放
        controls: true // 显示播放的控件
      },
      passagewayNum: 0,
      tabIndex: 0,
      areaInfo: {
        id: ''
      },
      areaLs: null,
      videoOptions: {
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        autoplay: true, // 设置自动播放
        controls: true,
        controlBar: { playToggle: false },
        // controlBar: { // 设置控制条组件
        //   children: [
        //     // {name: 'playToggle'}, // 播放按钮
        //     // {name: 'currentTimeDisplay'}, // 当前已播放时间
        //     // {name: 'progressControl'}, // 播放进度条
        //     // {name: 'durationDisplay'}, // 总时间
        //     {name: 'FullscreenToggle'} // 全屏
        //   ]
        // },
        language: 'zh-CN',
        liveui: true,
        notSupportedMessage: '视频地址失效',
        hls: {
          withCredentials: true
        }
      },

      showDetail: null,
      player: null,
      errorMsg: null,
      isShowPhoto: false,
      infoPhotoUrl: ''
      // itemInfo: JSON.parse(localStorage.getItem('itemInfo'))
    };
  },
  created() {},
  async mounted() {
    console.log(JSON.parse(localStorage.getItem('userInfo_ZHXM')), 'zzxm');
    if (JSON.parse(localStorage.getItem('userInfo_ZHXM'))) {
      this.areaLs = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
      this.areaInfo.id = JSON.parse(localStorage.getItem('userInfo_ZHXM')).authProvincesCityAreas;
    }

    // this.itemInfo = JSON.parse(localStorage.getItem('itemInfo'));
    // console.log(this.itemInfo, 'this.itemInfo');
    await this.getType();
    await this.getList();

    await this.getAreaList();
  },
  methods: {
    qualificationsClose() {
      this.isShowPhoto = false;
    },
    // 搜索 / 重置 - 左侧 / 中间
    searchEvent(item, type) {
      switch (item.event) {
        case 'resetForm':
          this.reset();
          break;
        case 'submitForm':
          this.onSubmit();
          break;
        default:
          break;
      }
    },
    toMap() {
      window.open('https://www.amap.com/search?query=' + this.detail.address + '&zoom=8.54');
    },
    imgError(e, item, index) {
      console.log(e + 'werwerwe');
      this.accessList[index].videoThumb = 'https://weimuyun-h5.oss-cn-hangzhou.aliyuncs.com/images/imgError.png';
      console.log(this.accessList[index]);
    },
    getAreaList() {
      selectByAreas(this.areaInfo).then(res => {
        this.option = res.data.data;
      });
    },
    getList() {
      if (this.areaLs) {
        if (this.areaLs.provincialAndMunicipalLevel == 1) {
          this.queryInfo.butcherProvinces = this.areaLs.authProvincesCityAreas;
          this.queryInfo.butcherCities = '';
        }
        if (this.areaLs.provincialAndMunicipalLevel == 2) {
          this.queryInfo.butcherCities = this.areaLs.authProvincesCityAreas;
        }
        if (this.areaLs.provincialAndMunicipalLevel == 3) {
          this.queryInfo.butcherArea = this.areaLs.authProvincesCityAreas;
          this.queryInfo.butcherCities = '';
        }
      }

      this.loading = true;
      getButcherBeanList(this.queryInfo).then(res => {
        this.loading = false;
        this.lists = res.data.data.records;
        this.total = res.data.data.total;

        if (this.lists.length > 0) {
          this.queryLsInfo.butcherId = this.lists[0].butcherId;
          this.detail = this.lists[0];
          this.listsDetail();
        } else {
          this.detail = {};
          this.accessList = [];
          this.passagewayNum = 0;
        }
      });
    },
    videoPlay(item, index) {
      // this.showDialogDetail = true
      // this.showDetail = item
      // var that = this
      console.log(item);
      this.$nextTick(() => {
        this.$set(item, 'videoSrc', item.hls);
        this.getVideo(index, `myVideo${item.deviceNo}`, item.videoSrc);
        // this.getVideo(index,`myVideo${item.deviceNo}`, 'https://open.ys7.com/v3/openlive/G50789542_1_1.m3u8?expire=1667314832&id=505153721131335680&t=6af50e0bc11139e55293afc9cf136ef5655a5fb425a022d638acbf8d8f0c80fd&ev=100')
      });
    },
    getVideo(index, id, nowPlayVideoUrl) {
      this.$set(this.accessList[index], 'player', videojs(id, this.videoOptions));
      //关键代码， 动态设置src，才可实现换台操作
      this.accessList[index].player.src([
        {
          src: nowPlayVideoUrl,
          type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
        }
      ]);
    },
    listsDetail() {
      this.accessListLodaing = true;
      this.accessList = [];
      getButcherLockBeanList(this.queryLsInfo).then(res => {
        this.accessList.forEach(item => {
          if (item.player) {
            item.player.dispose();
          }
        });
        res.data.data.records.forEach(item => {
          item.html =
            '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
            `myVideo${item.deviceNo}` +
            ' poster=' +
            item.videoThumb +
            ' muted ></video>';
        });
        this.accessList = res.data.data.records;
        this.accessListLodaing = false;

        this.videoIndex++;
        this.passagewayNum = res.data.data.total;

        // if (this.itemInfo.applicationId == 16) {
        //   setTimeout(() => {
        //     this.$refs.order.clickItem(this.detail.butcherId);
        //   }, 200);
        // }
      });
    },

    listItems(item, index) {
      this.tabIndex = index;
      this.detail = item;
      this.queryLsInfo.butcherId = item.butcherId;
      this.listsDetail();
    },
    getType() {
      findDictList({
        code: 'livestock_type'
      })
        .then(res => {
          this.types = res.data.data[0].children;
        })
        .catch(err => {
          // _this.$message.error('加载失败，请稍后再试！')
        });
    },
    onSubmit(e) {
      this.loading = true;
      this.queryInfo.current = 1;
      this.showDialogDetail = false;
      console.log(this.queryInfo);
      this.getList();
    },
    reset() {
      this.loading = true;
      if (this.areaLs) {
        if (this.areaLs.provincialAndMunicipalLevel == 1) {
          this.queryInfo.butcherProvinces = this.areaLs.authProvincesCityAreas;
          this.queryInfo.butcherCities = '';
          this.queryInfo.butcherArea = '';
        }
        if (this.areaLs.provincialAndMunicipalLevel == 2) {
          this.queryInfo.butcherCities = this.areaLs.authProvincesCityAreas;
          this.queryInfo.butcherArea = '';
          this.queryInfo.butcherProvinces = '';
        }
        if (this.areaLs.provincialAndMunicipalLevel == 3) {
          this.queryInfo.butcherArea = this.areaLs.authProvincesCityAreas;
          this.queryInfo.butcherCities = '';
          this.queryInfo.butcherProvinces = '';
        }
      }

      this.showDialogDetail = false;
      this.queryInfo.current = 1;
      this.queryInfo.livestockName = '';
      this.queryInfo.butcherName = '';
      this.levelValue = '';
      this.tabIndex = 0;
      this.getList();
    },
    currentPage(e) {
      console.log(e);
      this.queryInfo.current = e;
      this.getList();
    },
    prev(e) {
      this.queryInfo.current = e;
      this.getList();
    },
    next(e) {
      console.log(e);
      this.queryInfo.current = e;
      this.getList();
    },
    handleClick(tab, event) {
      this.handleIndex = tab.index;
    },
    checkInfo(detail) {
      this.infoPhotoUrl = '';
      queryUserCertFileList({
        auditStatus: '2',
        authInfo: '11',
        certType: '2',
        userPhone: detail.phone
      }).then(res => {
        console.log(res);
        if (res.data.data.length > 0) {
          this.infoPhotoUrl = res.data.data[0].certPositiveUrl;
        } else {
          this.infoPhotoUrl = noPhoto;
          console.log(this.infoPhotoUrl.indexOf('no_photo') > -1);
        }
        this.isShowPhoto = true;
      });
    }
  },
  beforeDestroy() {
    this.accessList.forEach(item => {
      if (item.player) {
        item.player.dispose();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.fixedTop {
  height: calc(100vh - 145px);
}
// .title {
//   margin-left: 20px;
// }
.el-tabs__item {
  width: 90px;
  height: 60px;
  text-align: center;
  font-size: 17px;
  padding: 5px 0;
  cursor: pointer;
}

.el-tabs__item.is-active {
  color: #30bf30;
  font-weight: bold;
}

.el-tabs__active-bar {
  width: 90px;
}

.el-tabs__nav-wrap::after {
  height: 1px;
}

// .el-button--primary {
//   float: right;
// }

// .el-button--primary:focus,
// .el-button--primary:hover {
//   background-color: #30bf30;
//   border-color: #30bf30;
// }

// .el-button--success.is-plain {
//   border-color: rgba(48, 191, 48, 1);
//   color: #30bf30 !important;
//   background: #fff;
// }

// .el-button--info.is-plain {
//   background: #fff;
//   color: #333;
//   border: 1px solid #dcdfe6 !important;
// }

.actionBox div {
  display: inline-block;
  margin: 0 5px;
}

.has-gutter tr th {
  background: #f5f7fa;
}

.el-table th.el-table__cell > .cell {
  color: #333;
  font-size: 14px;
}

.el-table .el-table__cell {
  font-size: 14px;
}
.checkInfo {
  cursor: pointer;
}
.jfStatesOpen {
  cursor: pointer;
  padding: 2px 15px;
  border-radius: 5px;
  font-size: 24px;
  /* border: 1px solid #e2e2e2; */

  margin-left: -10px;
  margin-top: 10px;
  color: #fff;
  background: #30bf30;
}

.nodata {
  margin: -100px auto 0 !important;
}

.main {
  min-height: calc(100vh - 150px) !important;
}

.tzcList {
  height: calc(100vh - 382px);
  overflow-y: auto;
}
.tzcBox {
  margin-top: 10px;
}

.tzcBoxL {
  width: 298px;
  height: auto;
  border: solid 1px rgb(225, 225, 225);
  background: rgba(245, 247, 250, 1);
  font-size: 16px;
  /*padding-bottom: 50px;*/
}

.tzcBoxL input {
  height: 40px;
  text-indent: 10px;
  font-size: 14px;
}

.tzcBoxL input::placeholder {
  color: #999;
}

.tzcBoxL .selects {
  width: calc(50% - 1px);
  /deep/ .el-input {
    .el-input__inner {
      border: none;
    }
  }
}

.borderNone,
.borderNone .el-input__inner {
  border-color: transparent !important;
  border-radius: 0;
}

.borderBot {
  height: 40px;
  border-top: solid 1px rgb(225, 225, 225);
  border-bottom: solid 1px rgb(225, 225, 225);
}

input:focus {
  outline: 0;
}

.btnBoxs {
  height: 40px;
  width: calc(50% - 1px);
}

//.btnBoxs button {
//  width: 50%;
//  float: left;
//  height: 40px;
//  text-align: center;
//  cursor: pointer;
//  border: none;
//  outline: none;
//  font-size: 16px
//}

.searchBtn {
  color: #30bf30;
  background: #fff;
}

.resetBtn {
  color: #333;
  background: rgba(245, 245, 245, 1);
}

.totals {
  line-height: 40px;
  text-indent: 10px;
  font-size: 14px;
  color: #999;
  border-bottom: solid 1px rgb(225, 225, 225);
}

.tzcItem {
  cursor: pointer;
  height: 39px;
  padding: 15px 10px;
  border-bottom: solid 1px rgb(225, 225, 225);
}

.tzcItem.cur {
  border: solid 2px #30bf30;
  background: #fff;
}

.namess {
  font-size: 16px;
  color: #333333;
  width: calc(100% - 40px);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.levelss {
  font-size: 12px;
  color: #1781ff;
  text-align: center;
  width: auto;
  height: 20px;
  background-color: rgba(221, 245, 255, 1);
  border-radius: 2px;
  line-height: 20px;
  padding: 0 5px;
}

.num,
.type {
  font-size: 14px;
  color: #999999;
  margin-top: 5px;
}

.tzcItem:hover .namess {
  //font-weight: bold;
  color: #30bf30;
}

.tzcBoxR {
  width: calc(100% - 320px);
  height: calc(100vh - 210px);
}

.accessName {
  border-bottom: solid 1px rgb(225, 225, 255);
  padding-bottom: 20px;
}

.accessName h3 {
  font-size: 20px;
  color: #333;
  margin: 0;
}

.accessName a {
  font-size: 14px;
  color: #666;
}

.accessName .type {
  width: auto;
  padding: 0 5px;
  height: 20px;
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  font-size: 12px;
  color: #666666;
  line-height: 20px;
  margin-top: 0;
  margin-left: 10px;
}

.named {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
  width: 330px;
}

.named a {
  cursor: pointer;
  color: #1781ff;
}

.accessNum {
  font-size: 14px;
  color: #666;
  line-height: 50px;
}

.accessList {
  height: calc(100vh - 415px);
  overflow-y: auto;
}

.accessItem {
  width: 100%;
  margin-bottom: 20px;
}

.accessImg {
  position: relative;
  width: 320px;
  height: 180px;
}
.accessImg .online {
  position: absolute;
  left: 0;
  top: 0;
  padding: 0 5px;
  line-height: 30px;
  z-index: 1;
}
.accessImg .video {
  width: 320px;
  height: 180px;
}

.accessImg img {
  width: 320px;
  height: 180px;
}

.accessImg div {
  position: absolute;
  left: 0;
  top: 0;
  width: 90px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.5);
}

.accessImg div.current {
  background: rgba(48, 191, 48, 0.7);
}

.accessBox {
  width: calc(100% - 340px);
  margin-left: 20px;
}

.accessNames {
  font-weight: 700;
  font-size: 16px;
  color: #333333;
  margin: 10px 0 10px 0;
  display: flex;
  align-items: center;
}

.accessNames span {
  display: inline-block;
  margin-right: 6px;
  width: 24px;
  height: 20px;
  background-color: rgba(245, 245, 245, 1);
  border-radius: 4px;
  font-size: 12px;
  color: #666666;
  line-height: 20px;
  font-weight: normal;
  text-align: center;
}

.accessInfo div {
  width: 50%;
  float: left;
}

.accessInfo div p {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin: 0;
}

.accessInfo h3 {
  font-size: 24px;
  color: #333;
  margin: 0;
}

.accessInfo h3 span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 5px;
}

.accessInfo div:nth-child(1) p,
.accessInfo div:nth-child(2) p {
  margin-top: 5px;
}

.accessInfo div:nth-child(1) h3,
.accessInfo div:nth-child(2) h3 {
  margin-top: 10px;
}

.accessInfo div:nth-child(3) p,
.accessInfo div:nth-child(4) p {
  margin-top: 15px;
}

.accessInfo div:nth-child(3) h3,
.accessInfo div:nth-child(4) h3 {
  margin-top: 5px;
  font-weight: normal;
  font-size: 20px;
}

/deep/ .video-js .vjs-big-play-button {
  font-size: 2em !important;
}

.titleShow {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 16px;
  font-weight: bold;
}
.ele-box {
  background: #fff;
  padding: 0 0 0 20px;
}
.mainPage .index-con .main-con .index-main {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/slaughterHouse/current.vue